import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { ApiService, AppContext, CacheService, LogService, AuthService, UserService, FavoriteService, BillingService } from './shared';
import { LoginComponent } from './login';
import '../style/app.scss';

@Component({
  selector: 'linescape-app',
  providers: [LogService, AppContext, ApiService, CacheService, AuthService, UserService, FavoriteService, BillingService],
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')],
})

export class AppComponent implements OnInit {
  url = 'linescape.com';
  versionNumber = '1.2';

  constructor(private log: LogService, private app: AppContext, private api: ApiService, private cache: CacheService,
    private auth: AuthService, private user: UserService, private billing: BillingService,
    private route: ActivatedRoute, private router: Router) {
    //this.checkCache();

    this.api.getApiClient().then(client => {
      this.user.init();
    });
  }

  ngOnInit() {
    if (window.location.pathname + window.location.search === '/') {
      this.app.searchType = 'schedule';
    }

    this.router.events.subscribe((event) => { 
      if (event instanceof NavigationEnd) {
        this.router.url == '/' ? this.app.openSearch('schedule') : this.app.closeSearch();
      }
    });
  }

  checkCache() {
    let version = localStorage.getItem('version');

    // check the length because a cognito id is saved on your first visit
    if (version !== this.versionNumber && localStorage.length > 1) {
      console.log('CLEARING CACHE', localStorage);
      localStorage.clear();
      localStorage.setItem('version', this.versionNumber);
    }
  }

  toggleMenu() {
    this.app.toggleMenu();
  }

  toggleSearch() {
    this.app.searchType ? this.app.closeSearch() : this.app.openSearch('schedule');
  }

  toggle(type: string) {
    this.app.toggleSearch(type);
  }

  scrollTop() {
    var scrollToTop = window.setInterval(function () {
      var pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 4);
  }

  logout() {
    this.app.closeSearch();
    sessionStorage.setItem('need-update-search-setting', 'true');
    this.api.signOut();
    //this.app.openSearch('schedule');
  }
}

// https://github.com/angular/angular/pull/10595/commits/f54f9efc0e70eb1c71ac8eb6a8ed690f1e7f09f9


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/app.component.ts